import React, { useState } from 'react';
import './BulkDataPage.css';

const BulkDataPage = () => {
  const [activeIndustry, setActiveIndustry] = useState('FMCG');
  const [expandedFAQ, setExpandedFAQ] = useState('How do I disburse Mobile Data?');

  const industries = [
    {
      id: 'fmcg',
      label: 'FMCG',
      description: 'Provide data vouchers with your product & drive sales.'
    },
    {
      id: 'banking',
      label: 'Banks & Insurance',
      description: 'Reward customers for signing up or using digital services.'
    },
    {
      id: 'digital',
      label: 'Digital Services',
      description: 'Drive app installations and increase user engagement.'
    },
    {
      id: 'retail',
      label: 'Retail & Manufacturing',
      description: 'Increase foot traffic and boost loyalty program sign-ups.'
    },
    {
      id: 'marketing',
      label: 'Marketing & Advertising',
      description: 'Improve campaign performance with mobile data incentives.'
    },
    {
      id: 'logistics',
      label: 'Logistics',
      description: 'Optimize delivery tracking and customer communication.'
    }
  ];

  const faqs = [
    {
      question: 'How do I disburse Mobile Data?',
      answer: (
        <div>
          <p>You can do this in 3 easy simple steps.</p>
          <p>i) Register on app.peakmobile.co.ke with your email and password</p>
          <p>ii) Top up your account with Data Units;</p>
          <p>iii) Upload the list of contacts you want to reward.</p>
          <p>iv) Select the data bundle you'd like to disburse.</p>
          <p>v) Click Submit The data will be sent directly to your contacts' mobile numbers in less than 2 seconds!</p>
        </div>
      )
    },
    {
      question: 'How much Mobile Data can I disburse?',
      answer: 'You can disburse mobile data from as low as 10MB to upto 10GB.'
    },
    {
      question: 'Does the Mobile Data expire?',
      answer: 'Bulk data on your account expires 90 days after purchase, while mobile data disbursed to a customer’s number is valid for 30 days.'
    },
    {
      question: 'How much does it cost?',
      answer: 'We offer tiered pricing based on data volume, please refer to our pricing page for more information.'
    },
    {
      question: 'Is it free to use the platform?',
      answer: 'Yes. We only charge you for the Mobile data you will distribute.'
    },
    {
      question: 'Is my customer data safe?',
      answer: 'Yes. We use secure cloud hosting, advanced authentication, and comply with data protection regulations to ensure the safety and privacy of your data.'
    }
  ];

  const toggleFAQ = (question) => {
    setExpandedFAQ(expandedFAQ === question ? null : question);
  };

  return (
    <div className="bulk-data-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>Bulk Data</h1>
          <p className="hero-description">Attract and engage customers with the power of mobile data.</p>
        </div>
        <div className="hero-background">
          <div className="circle-navy"></div>
          <div className="circle-light-blue"></div>
          <div className="circle-peach"></div>
        </div>
      </section>

      {/* Offer Section */}
      <section className="offer-section">
        <div className="offer-container">
          <div className="offer-image">
            <img src="/images/bulk-data.jpg" alt="Business people analyzing data charts" />
          </div>
          <div className="offer-content">
            <h2>Offer Free Data. Win More</h2>
            <h2 style={{marginBottom:'20px'}}>Customers.</h2>
            <p>We enable businesses to reward their customers'</p>
            <p style={{marginBottom:'20px'}}> loyalty, participation, adoption with Mobile Data.</p>

            <a
            href="https://app.peakmobile.co.ke/signin" 
            target="_blank"
            rel="noopener noreferrer">
              
            <button className="sign-up-button">Get Started →</button>

            </a>
          </div>
        </div>
      </section>

      {/* Platform Section */}
      <section className="platform-section-data">
        <h2>Mobile Data Platform</h2>
        <p className="platform-subtitle-data">Our self-service solution is built for businesses of all sizes, making mobile data distribution fast, easy, and seamless across a wide range of use cases.</p>

        <div className="features-grid-data">
          <div className="feature-card-data">
            <div className="feature-icon-data">
              <img src="/images/instant.svg" alt="Instant" />
            </div>
            <h3>Instant Bundle Allocation</h3>
            <p>Disburse Mobile data bundles in Seconds.</p>
          </div>

          <div className="feature-card-data">
            <div className="feature-icon-data">
              <img src="/images/icons/value.svg" alt="Value" />
            </div>
            <h3>Value</h3>
            <p>Offers instant Value to Customers.</p>
          </div>

          <div className="feature-card-data">
            <div className="feature-icon-data">
              <img src="/images/icons/control.svg" alt="Control" />
            </div>
            <h3>Full Control</h3>
            <p>Manage and disburse mobile data resources with an intuitive dashboard.</p>
          </div>

          <div className="feature-card-data">
            <div className="feature-icon-data">
              <img src="/images/icons/flexible-icon.svg" alt="Flexible" />
            </div>
            <h3>Flexible</h3>
            <p>Disburse Mobile Data of any Size in any way you choose.</p>
          </div>

          <div className="feature-card-data">
            <div className="feature-icon-data">
              <img src="/images/icons/scalable-icon.svg" alt="Scalable" />
            </div>
            <h3>Scalable</h3>
            <p>Manually disburse data or automatically via API or give physical data voucher cards.</p>
          </div>

          <div className="feature-card-data">
            <div className="feature-icon-data">
              <img src="/images/icons/roi-icon.svg" alt="ROI" />
            </div>
            <h3>ROI</h3>
            <p>Run targeted promotions based on intent and customer behavior.</p>
          </div>
        </div>
      </section>

      {/* Use Cases Section */}
      <section className="use-cases-section">
        <h2>Industry Use Cases</h2>
        
        <div className="use-cases-container">
          <div className="industry-selector">
            {industries.map(industry => (
              <div 
                key={industry.id}
                className={`industry-option ${industry.label === activeIndustry ? 'active' : ''}`}
                onClick={() => setActiveIndustry(industry.label)}
              >
                <div className="industry-name">{industry.label}</div>
                {industry.label === activeIndustry && (
                  <div className="industry-description">{industry.description}</div>
                )}
                <div className="arrow-icon">›</div>
              </div>
            ))}
          </div>
          
          <div className="use-case-image">
            <img src="/images/use-case.jpg" alt="Mobile data use case illustration" />
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section className="faqs-section">
        <h2>FAQs</h2>
        
        <div className="faqs-container">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <div 
                className="faq-question"
                onClick={() => toggleFAQ(faq.question)}
              >
                <span>{faq.question}</span>
                <span className={`faq-arrow ${expandedFAQ === faq.question ? 'expanded' : ''}`}>
                  ▼
                </span>
              </div>
              {expandedFAQ === faq.question && (
                <div className="faq-answer">
                  {typeof faq.answer === 'string' ? <p>{faq.answer}</p> : faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

    </div>
  );
};

export default BulkDataPage;